import BubbleCommon, { realtimeStreamingCustomTimeRange } from '@op/components/BubbleCommon';
import useLanguage from '@op/hooks/useLanguage';
import { getLiveTimeTitle } from '@op/pages/RealtimeStreaming/utils';
import React from 'react';
import { RadioGroup, Radio } from 'tea-component';

interface SwitchControlsProps {
  brushMode: 'latest5min' | 'adjustable';
  onBrushModeChange: (mode: 'latest5min' | 'adjustable') => void;
  selectedTimeRange?: { startTime: string; endTime: string } | null;
}

const SwitchControls: React.FC<SwitchControlsProps> = ({
  brushMode,
  onBrushModeChange,
  selectedTimeRange,
}) => {
  const { formatMessage } = useLanguage();

  return (
    <div className="switch-controls-wrapper">
      <span className="switch-controls-title">
        {formatMessage({ id: 'Analysis Time Range' })}
      </span>
      <RadioGroup
        value={brushMode}
        onChange={(value) =>
          onBrushModeChange(value as 'latest5min' | 'adjustable')
        }
        className="switch-controls"
      >
        <Radio name="latest5min">
          {formatMessage('Analyze latest the 5-min clip')}
        </Radio>
        <BubbleCommon showIcon={false} placement='top' tipsMap={realtimeStreamingCustomTimeRange}>
          <Radio name="adjustable">
            {formatMessage('Custom Analysis Time Range')}
          </Radio>
        </BubbleCommon>
      </RadioGroup>

      {/* Selected Time Range Display */}
      {brushMode === 'adjustable' && selectedTimeRange && (
        <span>({getLiveTimeTitle(selectedTimeRange)})</span>
      )}
    </div>
  );
};

export default SwitchControls;
